import { ILanguageCode } from "api/interfaces/app.interface";
import { getCurrentLangName } from "helpers/String.helper";

let commonData: any = {};
let languageCode: string = "ko";
export const setAllCodeList = async (allCodeList: any) => {
  Object.keys(allCodeList).forEach((key) => {
    commonData[key] = allCodeList[key];
  });
};

export const setCommonCodeList = (commonCodeList: any) => {
  commonData["commonCodeList"] = commonCodeList;
};
export const getCommonCodeList = () => {
  return commonData["commonCodeList"];
};
export const getCommonCodeListByParent = (parent: string) => {
  return commonData["commonCodeList"].filter(
    (code: any) => code.parentCode === parent
  ).sort((a: any, b: any) => {
    if (a.sequence < b.sequence) {
      return -1;
    }
    if (a.sequence > b.sequence) {
      return 1;
    }
    return 0;
  });
};

export const getProductTypeCodeList = () => {
  return getCommonCodeListByParent("productType");
};

export const getReportTypeCodeList = () => {
  return getCommonCodeListByParent("reportType");
};

export const getMessageReportReasonCodeList = () => {
  return getCommonCodeListByParent("messageReportReason");
};


export const getBloodTypeCodeList = () => {
  return getCommonCodeListByParent("bloodType");
};


export const getCommonCodeInfo = (parmaCode: string) => {
  return commonData["commonCodeList"].find(
    (code: any) => code.code === parmaCode
  );
};

export const setCountryCodeList = (countryCodeList: any) => {
  commonData["countryCodeList"] = countryCodeList;
};

export const getCountryCodeList = () => {
  console.log("common.data:getCountryCodeList");
  let sortedCountryList = [...commonData.countryCodeList].sort((a, b) => {
    if (getCurrentLangName(a.names) < getCurrentLangName(b.names)) {
      return -1;
    }
    if (getCurrentLangName(a.names) > getCurrentLangName(b.names)) {
      return 1;
    }
    return 0;
  });
  return sortedCountryList;
};

export const getCountryPhoneCodeList = () => {
  console.log("common.data:getCountryPhoneCodeList");
  const sortedCountryPhoneList = [...commonData.countryPhoneCodeList].sort((a, b) => {
    if (getCurrentLangName(a.names) < getCurrentLangName(b.names)) {
      return -1;
    }
    if (getCurrentLangName(a.names) > getCurrentLangName(b.names)) {
      return 1;
    }
    return 0;
  });
  return sortedCountryPhoneList;
};

//* 국가번호코드 리스트를 국가코드와 매칭하여 국가명이 포함된 정렬된 리스트 반환
//  2025.03.04
//  희문
export const getOrderedCountryPhoneCodeListWithCountryNames = () => {
  console.log("common.data:getOrderedCountryPhoneCodeListWithCountryNames");
  const countryPhoneCodeList = getCountryPhoneCodeList();
  const countryCodeList = getCountryCodeList();
  
  // countryPhoneCodeList의 countryCode를 countryCodeList와 매칭하여 국가명 가져오기
  // countryInfo가 존재하는 항목만 포함
  const mappedList = countryPhoneCodeList
    .map((phoneCodeItem: any) => {
      const countryInfo = countryCodeList.find((country: any) => country.code === phoneCodeItem.countryCode);
      if (!countryInfo) {
        return null;
      }
      return {
        ...phoneCodeItem,
        countryNames: countryInfo.names
      };
    })
    .filter((item: any) => item !== null);
  
  // 국가명으로 정렬
  return mappedList.sort((a, b) => {
    const nameA = getCurrentLangName(a.countryNames || a.names);
    const nameB = getCurrentLangName(b.countryNames || b.names);
    return nameA > nameB ? 1 : -1;
  });
};

export const getLanguageCodeList = (): ILanguageCode[] => {
  console.log("common.data:getLanguageCodeList");
  const sortedLanguageList = [...commonData.languageCodeList].sort((a, b) => {
    if (a.sequence < b.sequence) {
      return -1;
    }
    if (a.sequence > b.sequence) {
      return 1;
    }
    return 0;
  });
  return sortedLanguageList;
};

export const setMbtiCodeList = (mbtiCodeList: any) => {
  commonData["mbtiCodeList"] = mbtiCodeList;
};
export const getMbtiCodeList = () => {
  return commonData["mbtiCodeList"];
};
export const getSpecialtyCodeList = () => {
  return getCommonCodeListByParent("specialty");
};

export const setScoreCodeList = (mbtiCodeList: any) => {
  commonData["scoreCodeList"] = mbtiCodeList;
};
export const getScoreCodeList = () => {
  return commonData["scoreCodeList"];
};

export const setLanguageCode = (langCode: string) => {
  languageCode = langCode;
};
export const getLanguageCode = (onlyLanguageCode: boolean = true) => {
  if (onlyLanguageCode) {
    return languageCode.split("-")[0];
  } else {
    return languageCode;
  }
};

export const setTermsList = (termsList: any) => {
  commonData["termsList"] = termsList;
};
export const getTermsList = () => {
  return commonData["termsList"];
};

export const getKoachTypeCodeList = () => {
  return getCommonCodeListByParent('koachType');
}

export const getWithdrawalReasonCodeList = () => {
  return getCommonCodeListByParent('withdrawalReason');
}